import {
  format, addDays, startOfWeek, endOfWeek, parseISO, startOfMonth, endOfMonth, eachDayOfInterval, differenceInCalendarDays,
} from "date-fns";

export const ymd = (d) => format(d, "yyyy-MM-dd");
export const mondayOf = (d) => startOfWeek(d, { weekStartsOn: 1 });
export const weekDays = (monday) => Array.from({ length: 7 }, (_, i) => addDays(monday, i));
export const fmt = (s, f) => format(typeof s === "string" ? parseISO(s) : s, f);
export const todayStr = () => ymd(new Date());
export const daysBetween = (a, b) => differenceInCalendarDays(parseISO(b), parseISO(a)) + 1;

export function rangeFor(view, anchor) {
  if (view === "day") return [anchor, anchor];
  if (view === "week") {
    const m = mondayOf(anchor);
    return [m, addDays(m, 6)];
  }
  return [mondayOf(startOfMonth(anchor)), endOfWeek(endOfMonth(anchor), { weekStartsOn: 1 })];
}

export const daysInRange = (from, to) => eachDayOfInterval({ start: from, end: to });

export function itemsForDay(data, day, userId) {
  const mine = (id) => !userId || id === userId;
  return {
    shifts: data.shifts.filter((s) => s.date === day && mine(s.user_id)),
    tasks: data.tasks
      .filter((t) => t.due?.slice(0, 10) === day && mine(t.assignee_id))
      .sort((a, b) => a.due.localeCompare(b.due)),
    holidays: data.holidays.filter((h) => h.start_date <= day && h.end_date >= day && mine(h.user_id)),
  };
}

export const hoursOf = (s) => {
  const [sh, sm] = s.start.split(":").map(Number);
  const [eh, em] = s.end.split(":").map(Number);
  return (eh * 60 + em - sh * 60 - sm) / 60;
};
